import { isPrepaymentDefinition } from './getPrepaymentSummary';
import { toPrepaymentPercent } from './toPrepaymentPercent';
import type { PrepaymentSource } from '../model/types';

export function getPrepaymentPercents(product: Pick<PrepaymentSource, 'firstPaymentDefinitions'>): number[] {
  return (product.firstPaymentDefinitions ?? [])
    .filter((definition) => isPrepaymentDefinition(definition))
    .map((definition) => toPrepaymentPercent(definition.firstPaymentPart));
}
